// extracted by mini-css-extract-plugin
module.exports = {"cardUploader":"uploaderCardImage_cardUploader__3Aw9c","image":"uploaderCardImage_image__396VT"};